const themeToggleDarkIcon = document.getElementById('theme-toggle-dark-icon');
const themeToggleLightIcon = document.getElementById('theme-toggle-light-icon');
const themeToggleBtn = document.getElementById('theme-toggle');

const setVisibleThemeIcon = (isDarkTheme) => {
    if (!themeToggleDarkIcon || !themeToggleLightIcon) {
        return;
    }

    themeToggleDarkIcon.classList.toggle('hidden', isDarkTheme);
    themeToggleLightIcon.classList.toggle('hidden', !isDarkTheme);
};

const isDarkThemeEnabled = () =>
    localStorage.getItem('color-theme') === 'dark' ||
    (!('color-theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches);

setVisibleThemeIcon(isDarkThemeEnabled());

if (themeToggleBtn) {
    themeToggleBtn.addEventListener('click', function() {
        let event = new Event('dark-mode');

        /* if set via local storage previously */
        if (localStorage.getItem('color-theme')) {
            if (localStorage.getItem('color-theme') === 'light') {
                document.documentElement.classList.add('dark');
                localStorage.setItem('color-theme', 'dark');
            } else {
                document.documentElement.classList.remove('dark');
                localStorage.setItem('color-theme', 'light');
            }

        /* if NOT set via local storage previously */
        } else {
            if (document.documentElement.classList.contains('dark')) {
                document.documentElement.classList.remove('dark');
                localStorage.setItem('color-theme', 'light');
            } else {
                document.documentElement.classList.add('dark');
                localStorage.setItem('color-theme', 'dark');
            }
        }

        setVisibleThemeIcon(document.documentElement.classList.contains('dark'));

        document.dispatchEvent(event);
    });
}
